import {
  isNumber,
  isObject,
  isString
} from '../../../../../../utils/type-guards';

export class SelectOption {
  value: any = null;
  label = '';
  selected = false;
  disabled = false;

  constructor(origin: unknown, labelKey = '', valueKey = '') {
    if (isString(origin)) this.value = this.label = origin;

    if (isNumber(origin)) {
      this.value = origin;
      this.label = origin.toString();
    }

    if (isObject(origin)) {
      this.value = this.useProperty(origin, valueKey)
        ? origin[valueKey]
        : origin;
      this.label = this.useProperty(origin, labelKey) ? origin[labelKey] : '';
      this.disabled = this.useProperty(origin, 'disabled')
        ? origin['disabled']
        : false;
    }
  }

  private useProperty(source: object, key: string) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      source &&
      key &&
      key.length &&
      Object.prototype.hasOwnProperty.call(source, key)
    );
  }
}
